var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 27",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.68,12.41h-4.55V7.86c0-0.46-0.51-0.72-0.86-0.72c-0.35,0-0.86,0.26-0.86,0.72v4.55H7.86 c-0.46,0-0.72,0.51-0.72,0.86c0,0.35,0.25,0.86,0.72,0.86h4.55v4.55c0,0.46,0.51,0.72,0.86,0.72c0.35,0,0.86-0.26,0.86-0.72v-4.55 h4.55c0.46,0,0.72-0.51,0.72-0.86C19.4,12.92,19.15,12.41,18.68,12.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.27,0C5.95,0,0,5.95,0,13.27s5.95,13.27,13.27,13.27s13.27-5.95,13.27-13.27S20.59,0,13.27,0z M13.27,25.04 c-6.49,0-11.77-5.28-11.77-11.77S6.78,1.5,13.27,1.5s11.77,5.28,11.77,11.77S19.76,25.04,13.27,25.04z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleIcon);
export default __webpack_public_path__ + "static/media/plus-circle-icon.cb908eb335343664c82f405442549159.svg";
export { ForwardRef as ReactComponent };